module.exports = __webpack_public_path__ + "static/media/goat-transparent.5e2aff9a.png";